<template>
  <el-main :style="{height:height+'px'}" v-loading="loading">
    <div class="Scroll_content">
      <div class="breadcrumb">
        <router-link to="/home">{{ $t('addChildren.breadcrumbHome') }}</router-link>
        <span class="breadcrumb-sep">/</span>
        <span>{{ $t('addChildren.breadcrumbEdit') }}</span>
      </div>

      <div class="simkeropl">{{ $t('addChildren.Edits') }}</div>

      <div class="children-grid">
        <div
          class="child-card"
          v-for="(item,index) in studentData"
          :key="index"
          @click="switch_id(item)"
          :class="{ 'is-selected': last_student_sn == item.student_sn }"
        >
          <div v-if="last_student_sn == item.student_sn" class="selected-badge">
            <i class="el-icon-check"></i>
          </div>
          <img class="icon_dax" :src="item.avatar" alt="">
          <div class="child-info">
            <span class="tim_nam">{{ $t('addChildren.Childs_Name') }}</span> &nbsp;&nbsp;
            <span class="mingziss">{{ item.nickname }}</span>
          </div>
          <div class="child-info">
            <span class="minzizi">{{ $t('addChildren.Child_Birthday') }}</span> &nbsp;&nbsp;
            <span class="hanimsj">{{ item.birth_date }}</span>
          </div>
          <div class="xiugaim" @click="editChild(item,$event)">
            <img class="xg" src="../../assets/xiugai.png" alt="">
            {{ $t('addChildren.Edit') }}
          </div>
        </div>

        <div class="child-card add-card" @click="addChild">
          <div class="add-icon-wrap">
            <img class="add-icon" src="../../assets/img/add-child-icon.png" alt="">
          </div>
          <div class="add-text">{{ $t('addChildren.addNew') }}</div>
        </div>
      </div>

      <div class="dian"></div>
    </div>

    <student-form-dialog
      :visible.sync="formVisible"
      :mode="formMode"
      :student="editStudent"
      @success="onFormSuccess"
    />

    <el-dialog class="dialog"
      title=""
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose">
      <span> {{ $t('Childdialog.Parent') }} </span>
      <span> {{ $t('Childdialog.advisor') }}  </span>
      <div>
        <div class="sin_boimn">
          <img class="immkkll" src="../../assets/Stroke1.svg" alt="">
          <span style="color: #0B1D33;">{{ user_info.mobile }}</span>
        </div>
        <div class="sin_boimn">
          <img class="immkkll wx" src="../../assets/WeChat_lgo_icon1.svg" alt="">
          <span> {{ user_info.wechat }}</span>
        </div>
        <img class="ewm_img" :src="user_info.qr_code" alt="">
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import { setStore, getStore, keys } from '@/store';
import StudentFormDialog from './StudentFormDialog.vue';

export default {
  components: {
    StudentFormDialog
  },
  data () {
    return {
      loading: false,
      height: 100,
      studentData: [],
      last_student_sn: '',
      num: 3,
      dialogVisible: false,
      formVisible: false,
      formMode: 'add',
      editStudent: null,
      user_info: [],
    }
  },
  created () {
    let height = document.body.offsetHeight - 164;
    this.height = height
    if (getStore(keys.token)) {
      if (getStore(keys.userInfo).status == 0) {
        this.$router.push({
          path: '/onboarding'
        })
      }
    } else {
      this.$router.push({
        path: '/'
      })
      return false
    }
    this.num = getStore(keys.userProfile).member_status == '1' ? getStore(keys.userProfile).member_kids : 3
    this.get_children_all();
    this.getUser();
    this.Sales_information();
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
    },
    Sales_information: function () {
      this.$http.get('/api/getMemberMess', { headers: { token: getStore(keys.token) } }).then((res) => {
        if (res.data.code == 200) {
          setStore(keys.user, res.data.data)
          this.user_info = res.data.data.salesperson_info
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    get_children_all: function () {
      this.$http.get('/api/learner').then((res) => {
        if (res.data.code == 200) {
          this.studentData = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    editChild (item, e) {
      this.formMode = 'edit'
      this.editStudent = item
      this.formVisible = true
      e.cancelBubble = true;
    },
    addChild () {
      if (this.studentData.length >= this.num) {
        this.dialogVisible = true
      } else {
        this.formMode = 'add'
        this.editStudent = null
        this.formVisible = true
      }
    },
    onFormSuccess () {
      this.get_children_all()
      this.getUser()
      if (this.$parent && this.$parent.getUser) {
        this.$parent.getUser()
      }
    },
    switch_id (e) {
      this.$http.post('/api/saveLastLearner?', {
        last_student_sn: e.student_sn
      }).then((res) => {
        if (res.data.code == 200) {
          this.getUser();
          if (this.$parent && this.$parent.getUser) {
            this.$parent.getUser();
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    getUser () {
      this.loading = true;
      this.$http.get('/api/member/data').then((res) => {
        if (res.data.code == 200) {
          this.last_student_sn = res.data.data.last_student_sn
          this.loading = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
}
</script>

<style lang="less" scoped>
.breadcrumb {
  font-size: 14px;
  color: #999;
  margin-bottom: 16px;

  a {
    color: #999;
    text-decoration: none;

    &:hover {
      color: #b50604;
    }
  }

  .breadcrumb-sep {
    margin: 0 8px;
  }
}

.simkeropl {
  margin-bottom: 32px;
  font-family: Roboto;
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  color: #000000;
}

.children-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}

.child-card {
  position: relative;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  overflow: hidden;
  cursor: pointer;
  width: 23.5%;
  min-height: 220px;
  padding-bottom: 16px;

  &.is-selected {
    border: 2px solid #b50604;
  }
}

.child-info{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
}
.selected-badge {
  position: absolute;
  top: 0;
  right: 0;
  width: 28px;
  height: 28px;
  background: #b50604;
  border-radius: 0 10px 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
}

.icon_dax {
  width: 72px;
  height: 72px;
  margin: 24px auto 30px;
  display: block;
  border-radius: 50%;
  object-fit: cover;
}

.tim_nam,
.minzizi {
  font-size: 14px;
  line-height: 16px;
  color: #6b6b6b;
  display: block;
  text-align: center;
}

.mingziss,
.hanimsj {
  font-size: 16px;
  line-height: 18px;
  color: #000000;
  display: block;
  text-align: center;
}

.xiugaim {
  width: 100%;
  height: 36px;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #b50604;
  cursor: pointer;
  margin-top: 20px;
  .xg {
    margin-right: 8px;
    width: 16px;
  }
}

.add-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 220px;
}

.add-icon-wrap {
  width: 18px;
  height: 18px;
  margin-bottom: 16px;
}

.add-icon {
  width: 100%;
  height: 100%;
}

.add-text {
  font-size: 16px;
  font-weight: 500;
  color: #b50604;
}

.dialog {
  span {
    display: block;
    text-align: center;
    font-weight: 700;
    font-size: 18px;
    line-height: 150%;
    color: #000000;
    width: 380px;
    word-break: break-word;
    margin: 10px auto;
  }

  .sin_boimn {
    width: 60%;
    margin: 20px auto;
    display: flex;
    align-items: center;

    .immkkll {
      width: 24px;
      height: 24px;
      flex-shrink: 0;
      object-fit: contain;
    }

    span {
      margin-left: 20px;
      text-align: left;
    }
  }
}

.ewm_img {
  width: 106px;
  height: 106px;
  margin: 40px auto 20px auto;
  display: block;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/children/addChildren.vue